module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "printForm"
  }, [_c('h2', [_c('Icon', {
    attrs: {
      "icon": "print"
    }
  }), _vm._v(_vm._s(_vm._translate('print.title')))], 1), _vm._v(" "), _c('form', {
    staticClass: "printForm__container"
  }, [_c('div', {
    staticClass: "printForm__panel printForm__sections"
  }, [_c('h3', [_vm._v(_vm._s(_vm._translate('print.printSections')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._translate('print.printSectionsDetails')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useCover",
      "label": _vm._translate('print.printCoverPage'),
      "field": "useCover",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useDisclaimer",
      "label": _vm._translate('print.printDisclaimer'),
      "field": "useDisclaimer",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), (_vm.hasClient()) ? _c('Checkbox', {
    attrs: {
      "id": "useProfile",
      "label": _vm._translate('print.printClientProfile'),
      "field": "useProfile",
      "value": "true",
      "modal": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasClient()) ? _c('Checkbox', {
    attrs: {
      "id": "useNetWorth",
      "label": _vm._translate('print.printNetWorthReport'),
      "field": "useNetWorth",
      "value": "true",
      "modal": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasClient()) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementPlanner",
      "label": _vm._translate('print.printRetirementPlannerReport'),
      "field": "useRetirementPlanner",
      "value": "true",
      "modal": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasClient()) ? _c('Checkbox', {
    attrs: {
      "id": "useGPS",
      "label": _vm._translate('print.printFinancialGpsReport'),
      "field": "useGPS",
      "value": "true",
      "modal": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.hasActiveTool()) ? _c('Checkbox', {
    attrs: {
      "id": "useTool",
      "label": _vm.getActiveToolName(),
      "field": "useTool",
      "value": "true",
      "modal": "true"
    }
  }) : _vm._e(), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useTool",
      "label": _vm._translate('print.printGlobalDisclaimers'),
      "field": "useDisclaimers",
      "value": "true",
      "modal": "true"
    }
  })], 1), _c('div', {
    staticClass: "printForm__panel printForm__subsections"
  }, [_c('h3', [_vm._v(_vm._s(_vm._translate('print.printSubsections')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._translate('print.printSubsectionsDetails')))]), _vm._v(" "), _c('Dropdown', {
    attrs: {
      "id": "lang",
      "field": "printLanguage",
      "label": _vm._translate('print.reportLanguage'),
      "proto": "calc.language",
      "context": "modal"
    }
  }), _vm._v(" "), _c('TextInput', {
    attrs: {
      "id": "printTitleBox",
      "label": _vm._translate('print.reportTitle'),
      "field": _vm.getTitleDefault(),
      "context": "modal",
      "replace": "name"
    }
  }), _vm._v(" "), (_vm.sectionControls('useDisclaimer')) ? _c('div', [_c('Dropdown', {
    attrs: {
      "id": "gender",
      "field": "printDisclaimer",
      "label": _vm._translate('print.selectDisclaimer'),
      "proto": "calc.disclaimers",
      "context": "modal"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sectionControls('useNetWorth') && _vm.hasClient()) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm._translate('print.netWorthSections')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useNetworthTotal",
      "label": _vm._translate('print.includeNetWorthSummary'),
      "field": "useNetworthTotal",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useNetworthComp",
      "label": _vm._translate('print.includeAssetLiabilityComparison'),
      "field": "useNetworthComp",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useNetworthBreakdown",
      "label": _vm._translate('print.includeAssetsAccountsBreakdown'),
      "field": "useNetworthBreakdown",
      "value": "true",
      "modal": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sectionControls('useRetirementPlanner') && _vm.hasClient()) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm._translate('print.retirementPlannerSection')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useRetirementOutlook",
      "label": _vm._translate('print.includeRetirementOutlook'),
      "field": "useRetirementOutlook",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useRetirementIncome",
      "label": _vm._translate('print.includeRetirementIncomeRequired'),
      "field": "useRetirementIncome",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useRetirementBenefits",
      "label": _vm._translate('print.includeGovernmentBenefits'),
      "field": "useRetirementBenefits",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useRetirementPension",
      "label": _vm._translate('print.includePension'),
      "field": "useRetirementPension",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useRetirementValues",
      "label": _vm._translate('print.includeAssetValues'),
      "field": "useRetirementValues",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), (_vm.tableHasData('wealthAccumulationData')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementWealthAccumulation",
      "label": _vm._translate('print.includeWealthAccumulation'),
      "field": "useRetirementWealthAccumulation",
      "value": "true",
      "modal": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableHasData('wealthAccumulationData') && _vm.sectionControls('useRetirementWealthAccumulation')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementWealthAccumulationGraph",
      "label": _vm._translate('print.includeChart'),
      "field": "useRetirementWealthAccumulationGraph",
      "value": "true",
      "modal": "true",
      "indent": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableHasData('wealthAccumulationData') && _vm.sectionControls('useRetirementWealthAccumulation')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementWealthAccumulationTable",
      "label": _vm._translate('print.includeTable'),
      "field": "useRetirementWealthAccumulationTable",
      "value": "true",
      "modal": "true",
      "indent": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableHasData('systematicWithdrawalsData')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementDeacumulation",
      "label": _vm._translate('print.includeWealthDeaccumulation'),
      "field": "useRetirementDeacumulation",
      "value": "true",
      "modal": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableHasData('systematicWithdrawalsData') && _vm.sectionControls('useRetirementDeacumulation')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementDeacumulationGraph",
      "label": _vm._translate('print.includeChart'),
      "field": "useRetirementDeacumulationGraph",
      "value": "true",
      "modal": "true",
      "indent": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableHasData('systematicWithdrawalsData') && _vm.sectionControls('useRetirementDeacumulation')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementDeacumulationTable",
      "label": _vm._translate('print.includeTable'),
      "field": "useRetirementDeacumulationTable",
      "value": "true",
      "modal": "true",
      "indent": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableHasData('postRetirementCashFlowData')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementCashflows",
      "label": _vm._translate('print.includePostRetirementCashFlows'),
      "field": "useRetirementCashflows",
      "value": "true",
      "modal": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableHasData('postRetirementCashFlowData') && _vm.sectionControls('useRetirementCashflows')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementCashflowsGraph",
      "label": _vm._translate('print.includeChart'),
      "field": "useRetirementCashflowsGraph",
      "value": "true",
      "modal": "true",
      "indent": "true"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tableHasData('postRetirementCashFlowData') && _vm.sectionControls('useRetirementCashflows')) ? _c('Checkbox', {
    attrs: {
      "id": "useRetirementCashflowsTable",
      "label": _vm._translate('print.includeTable'),
      "field": "useRetirementCashflowsTable",
      "value": "true",
      "modal": "true",
      "indent": "true"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.sectionControls('useGPS') && _vm.hasClient()) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm._translate('print.financialGpsSection')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useGPSOverview",
      "label": _vm._translate('print.includeGpsDetails'),
      "field": "useGPSOverview",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useGPSProjections",
      "label": _vm._translate('print.includeGpsProjections'),
      "field": "useGPSProjections",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useGPSShock",
      "label": _vm._translate('print.includeGpsResilience'),
      "field": "useGPSShock",
      "value": "true",
      "modal": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sectionControls('useDisclaimers')) ? _c('div', [_c('h4', [_vm._v(_vm._s(_vm._translate('print.disclaimerSection')))]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useDisclaimersGlobal",
      "label": _vm._translate('print.includeGlobalDisclaimer'),
      "field": "useDisclaimersGlobal",
      "value": "true",
      "modal": "true"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sectionControls('useTool')) ? _c('div', [_c('h4', [_vm._v("Tool Sections")]), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useToolChart",
      "label": "Include Tool Chart",
      "field": "useToolChart",
      "value": "true",
      "modal": "true"
    }
  }), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "id": "useToolTable",
      "label": "Include Tool Summary Table",
      "field": "useToolTable",
      "value": "true",
      "modal": "true"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "printForm__control"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.doPrint
    }
  }, [_vm._v(_vm._s(_vm._translate('print.button')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7aa54567!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrintForm/PrintForm.vue
// module id = 328
// module chunks = 0